import { render, staticRenderFns } from "./stepDelivery.vue?vue&type=template&id=0714f890&scoped=true&"
import script from "./stepDelivery.vue?vue&type=script&lang=ts&"
export * from "./stepDelivery.vue?vue&type=script&lang=ts&"
import style0 from "./stepDelivery.vue?vue&type=style&index=0&id=0714f890&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0714f890",
  null
  
)

export default component.exports